import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { UsersModule } from '../../Core/Users/users.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';

import { BriefingsModule } from '../Briefings/briefings.module';
import { AlertsModule } from '../Alerts/alerts.module';
import { MediaSubscriptionsModule } from '../MediaSubscriptions/media-subscriptions.module';
import { ReportsModule } from '../../Common/Reports/reports.module';

import { MediaSubscriptionApiService } from '../../api/mediaSubscriptions/media-subscription.api.service';
import { MentionsApi } from '../../api/mentions/mentions.api';
import { SavedMentionSearchesApi } from '../../api/mentions/saved-mention-searches.api';
import { TopicBackfillApi } from '../../api/backfills/topic-backfill.api';
import { AdminAccountsFoldersApi } from '../../api/adminAccountsFolders/adminAccountsFolders.api';

import { MonitoringComponent } from './components/Monitoring/monitoring.component';
import { MonitoringLeftSidebarService } from './services/monitoring-left-sidebar.service';
import { JournodexRegionsService } from '../../Common/Journodex/services/journodex-regions.service';
import { MediaSubscriptionService } from './services/media-subscription.service';
import { FolderService } from './services/folder.service';
import { MentionsService } from './services/mentions.service';
import { MonitoringRoutingService } from './services/monitoring-routing.service';
import { TopicsService } from './services/topics.service';
import { MentionSearchService } from './services/mention-search.service';
import { SearchResultsService } from './services/search-results.service';
import { JournodexModule } from '../../Common/Journodex/journodex.module';
import { MentionsModule } from '../../Common/Mentions/mentions.module';
import { MonitoringLeftSidebarManagementService } from './services/monitoring-left-sidebar-management.service';
import { DisplayGroupsService } from '../../Common/Layout/services/display-groups.service';
import { FoldersApiService } from '@api/folders/folders.api.service';
import { MonitoringDashboardSearchService } from './services/monitoring-dashboard-search.service';

@NgModule({
    imports: [
        /* Angular */
        CommonModule,
        FormsModule,

        /* Common/Core */
        LayoutModule,
        LocalizationModule,
        CommonDialogsModule,
        MiscModule,
        UsersModule,
        CommonFormsModule,
        JournodexModule,

        /* Monitor */
        BriefingsModule,
        AlertsModule,
        MediaSubscriptionsModule,
        ReportsModule,
        MentionsModule
    ],
    exports: [
        MonitoringComponent
    ],
    declarations: [
        MonitoringComponent    ],
    providers: [
        MediaSubscriptionApiService,
        MentionsApi,
        SavedMentionSearchesApi,
        TopicBackfillApi,
        FoldersApiService,

        /* Monitor Services */
        MonitoringLeftSidebarService,
        {
            provide: 'MonitoringLeftSidebarService',
            useExisting: MonitoringLeftSidebarService
        },
        MonitoringRoutingService,
        JournodexRegionsService,
        MediaSubscriptionService,
        {
            provide: 'MediaSubscriptionService',
            useExisting: MediaSubscriptionService
        },
        FolderService,
        {
            provide: 'FolderService',
            useExisting: FolderService
        },
        MentionsService,
        {
            provide: 'MentionsService',
            useExisting: MentionsService
        },
        TopicsService,
        {
            provide: 'TopicsService',
            useExisting: TopicsService
        },
        MonitoringDashboardSearchService,
        {
            provide: MentionSearchService,
            useExisting: MonitoringDashboardSearchService
        },
        SearchResultsService,
        AdminAccountsFoldersApi,
        MonitoringLeftSidebarManagementService,
        DisplayGroupsService,
    ]
})
export class MonitorCoreModule { }
